import React from 'react';
import { Phone, Clock, MapPin } from 'lucide-react';
import { Button } from './ui/button';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="relative min-h-[600px] lg:min-h-[700px] flex items-center bg-gray-900">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_crane-services-4/artifacts/ga8hnxmu_Screenshot_20260222_033040_Maps.jpg"
          alt="Servicio de grúas profesional"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/95 via-gray-900/80 to-gray-900/60"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-2xl">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Servicio de Grúas Profesional en Mendoza
          </h1>
          <p className="text-lg md:text-xl text-gray-200 mb-8 leading-relaxed">
            Traslado seguro de vehículos ligeros, pesados y maquinaria industrial. 
            Disponibles todos los días con la mejor atención.
          </p>

          {/* Quick Info Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
            <div className="flex items-center space-x-3 bg-white/10 backdrop-blur-sm p-4 rounded-lg border border-white/20">
              <Clock className="w-6 h-6 text-white flex-shrink-0" />
              <div>
                <p className="text-sm text-gray-300">Horario</p>
                <p className="text-white font-semibold text-sm">06:00 - 00:30</p>
              </div>
            </div>
            <div className="flex items-center space-x-3 bg-white/10 backdrop-blur-sm p-4 rounded-lg border border-white/20">
              <MapPin className="w-6 h-6 text-white flex-shrink-0" />
              <div>
                <p className="text-sm text-gray-300">Zona</p>
                <p className="text-white font-semibold text-sm">Mendoza - Zona este</p>
              </div>
            </div>
            <div className="flex items-center space-x-3 bg-white/10 backdrop-blur-sm p-4 rounded-lg border border-white/20">
              <Phone className="w-6 h-6 text-white flex-shrink-0" />
              <div>
                <p className="text-sm text-gray-300">Contacto</p>
                <p className="text-white font-semibold text-sm">261-2073173</p>
              </div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              onClick={scrollToContact}
              size="lg"
              className="bg-white text-gray-900 hover:bg-gray-100 font-semibold px-8"
            >
              Solicitar Servicio
            </Button>
            <a href="tel:2612073173">
              <Button 
                size="lg"
                variant="outline"
                className="w-full sm:w-auto bg-transparent border-2 border-white text-white hover:bg-white hover:text-gray-900 font-semibold px-8"
              >
                <Phone className="w-5 h-5 mr-2" />
                Llamar Ahora
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
